import { h } from 'preact';
import { trackableFetch } from 'utilities/network';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { ANNOTATION_EVENT, APPLICATION_EVENT } from 'constants/events';

import { InvisibleAnnotation } from 'rendering/components/invisible_annotation';

export class ConditionalSettingsProvider extends BaseAnnotation {
    constructor(...args) {
        super(...args);
        this.initLoaded();
    }

    initLoaded() {
        this.loadedResources = {};
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.content !== this.props.content) {
            return true;
        }

        if (nextProps.lastModified !== this.props.lastModified) {
            this.initLoaded();
            return true;
        }
    }

    render() {
        if (!this.contents) {
            return null;
        }

        if (!this.loadedResources[this.contents]) {
            this.loadedResources[this.contents] = 'loading';
            
            this.loadResource(this.contents)
                .then(() => this.eventBus.emit(APPLICATION_EVENT.DEPENDENCIES_LOADING, false))
                .then(() => this.forceUpdate());

            this.eventBus.emit(APPLICATION_EVENT.DEPENDENCIES_LOADING, true);
        }

        const debugAttrs = {
            ['data-annotation']: 'conditionalsettingsprovider',
            ['data-contents']: this.contents
        }

        return <InvisibleAnnotation { ...debugAttrs }/>;
    }

    loadResource(url) {
        if (url === null) {
            // null indicates no translations are provided for this language
            this.loadedResources[url] = true;            
            return Promise.resolve();
        }

        return (
            trackableFetch(url, { credentials: 'same-origin' })
                .then(res => res.json())
                .then(json => this.loadedResources[url] = json)
                .then(() => this.applyConditionalSettings(url))
                .catch(error => console.error(error))
        )
    }

    applyConditionalSettings(url) {
        requestAnimationFrame(() => {
            const arb = this.loadedResources[url];
            const conditions = arb['@@scope'];

            if (!conditions) {
                console.error('ARB is missing required @@scope. Settings cannot be applied!');
                return;
            }

            this.eventBus.emit(ANNOTATION_EVENT.CONDITIONAL_SETTINGS_LOADED, arb, conditions);
        })
    }

    get contents() {
        return this.props.content;
    }

    static get schemaType() {
        return 'conditionalsettingsprovider';
    }
}